import styled from "styled-components";

export default styled.span`
  text-align: center;
`;
